export interface CellI{
  ind: number;
  col: number;
  row: number;
  val: number;
  blockIndex: number;
  hasStaticVal: boolean;
  isValid?:boolean;
}

export class Sudoku{
  
  cells        : any = [];
  currentCell  : number  = 0;//backtrack
  clearedCells : number;

  constructor(clearedCells?: number){
    this.clearedCells  = clearedCells ? clearedCells : 70;
    this.resetSudoku();
    this.cells = this.initSudoku();
  }

  resetSudoku(){
    this.cells = [];
    this.currentCell = 0;
  }
  
  findBlockIndex(i:number, j:number) : number{
    let row = Math.floor(j / 3);
    let col = Math.floor(i / 3);
    
    return row*3+col;
  }

  initSudoku() : CellI[]{
    let arr = [];
    for(let i=0;i<9;i+=1){
      for(let j=0;j<9;j+=1){
        let cell = {
          ind: i*9 + j,
          col: j,
          row: i,
          val: 0,
          blockIndex: this.findBlockIndex(j,i),
          hasStaticVal: true
        }
        arr.push(cell)
      }
    }
    return arr;
  }
  
  exclude(cell : CellI) : number[]{
    let excluded = [];

    for(let i=0;i<81;i+=1){
      if( (this.cells[i].row === cell.row || 
        this.cells[i].col === cell.col || 
        this.cells[i].blockIndex === cell.blockIndex) &&
        this.cells[i].val){
          excluded.push(this.cells[i].val);
        }
    }
    return excluded;
  }

  giveNext(){

    if(this.currentCell > 80){
      return false;
    }

    let cell = this.cells[this.currentCell];
    let excluded = this.exclude(cell);
    let nums = [1,2,3,4,5,6,7,8,9];
    let filtered = nums.filter(n=>{return excluded.indexOf(n) === -1;});
    //console.log('e f: ', excluded, filtered);
    if(!filtered.length){
      console.log(this.currentCell);
      this.backtrack();
      return true;
    }

    let rand = Math.floor(Math.random()*filtered.length);
    cell.val = filtered[rand];

    this.currentCell+=1;
    
 
    return true; 
  }

  giveAnimating(){

    let next = true;
    let times = 0;
    let interval = setInterval(()=>{

      let next = this.giveNext();
      if(!next){
        clearInterval(interval);
        this.clearRandomCells();
      }
      times+=1;
      //console.log('times: '+ times);

    }, 1);


  }

  backtrack(){
    for(let i=1;i<9;i+=1){
      this.cells[this.currentCell-i].val = 0;
    }
    this.currentCell -= 8;
  }

  clearRandomCells(){
    let arr = [];
    for(let i=1;i<this.clearedCells;i+=1){
      let num = Math.floor(Math.random()*81);
      if(arr.indexOf(num) === -1){
        arr.push(num);
      }
      else{
        i-=1;
      }

    }

    for(let j=0;j<arr.length;j+=1){
      this.cells[arr[j]].val = 0;
      this.cells[arr[j]].hasStaticVal = false;
    }
  }

  checkIfValid(cell : CellI, val: number) : boolean{
    let excluded = [];
    for(let i=0;i<81;i+=1){
      if( (this.cells[i].row === cell.row || 
        this.cells[i].col === cell.col || 
        this.cells[i].blockIndex === cell.blockIndex) &&
        this.cells[i].val){
          excluded.push(this.cells[i].val);
        }
    }
    return !excluded.includes(val);
  }  
  
}